angular.module 'zc.masterApi'

.factory "MasterMongoVisitor", ($q, FacadeV2) ->


  class MasterMongoVisitor

    @find: (query, options={}) ->
      $q (resolve, reject) ->
        query ||= {}
        unless query._id
          return reject "no _id"

        FacadeV2.request "/master/visitors",
          params:
            match: query
            limit: options.limit || 1000
        .then (res) ->
          if res.status != 200 || res.data.error
            reject res.data.error
          else
            resolve res.data

  MasterMongoVisitor



// WEBPACK FOOTER //
// ./src/master_admin_modules/master_api/facade/master_mongo_visitor.service.coffee